<template>
  <div class="capture login-block">
    <div class="contain">
      <div class="text">
        <h2>Login.</h2>
        <p>
          Already have an account? Login below.
        </p>
      </div>
      <div class="form">
        <div class="inputs">
          <div class="input full">
            <label>Email Address <span class="required">*</span></label>
            <input type="email" v-model="user.email" />
          </div>
          <div class="input full">
            <label>Password <span class="required">*</span></label>
            <input @keyup="checkForCapLock" type="password" v-model="user.password" />
          </div>
          <transition name="fade-quick">
            <div v-if="!loading" class="btns">
              <button @click="validate()" class="btn">Login</button>
              <button @click="forgotPassword" class="btn text_btn forgot">
                Forgot Password
              </button>
              <p v-if="feedback" class="error">{{ feedback }}</p>
            </div>
          </transition>

          <transition name="fade-quick">
            <div class="btns" v-if="loading">
              <img class="login-loader" src="@/assets/img/loader.gif" />
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import axios from "axios";
import Swal from "sweetalert2";
import { auth, db } from "../firebaseConfig.js";

export default {
  name: "login",
  data() {
    return {
      user: {
        email: null,
        password: null,
      },
      status: "submit",
      feedback: null,
      loading: null,
    };
  },
  mounted() {},
  created() {},
  updated() {},
  methods: {
    validate() {
      this.loading = true;
      this.login();
    },
    login() {
      auth
        .signInWithEmailAndPassword(this.user.email, this.user.password)
        .then((user) => {
          setTimeout(() => {
            this.feedback = null;
            this.loading = false;
            this.goTo("/dashboard");
            this.$parent.showPopup = false;
          }, 500);
        })
        .catch((err) => {
          this.user.email = null;
          this.user.password = null;
          this.loading = false;
          this.feedback = err.message;
        });
    },
    forgotPassword() {
      this.$parent.showPopup = false;
      this.goTo("/forgot-password");
    },
    checkForCapLock(event) {
      if(event.getModifierState){
        var caps_lock_on = event.getModifierState('CapsLock');
        if (caps_lock_on) this.feedback = "Caps Lock On";
        else this.feedback = null;
      }
      else this.feedback = null;
    },
  },
};
</script>

<style scoped lang="scss">
.loginregister {
  padding-top: 50px;
  .contain {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .form {
      margin-top: 30px;
      @media screen and (max-width: 800px) {
        margin-top: -20px;
      }
    }
  }
}
.capture {
  width: 50%;
  @media screen and (max-width: 800px) {
    width: 100%;
  }
  &.register-block {
    padding-right: 50px;
    @media screen and (max-width: 800px) {
      padding-bottom: 30px;
      padding-right: 0;
    }
  }
  &.login-block {
    padding-left: 50px;
    border-left: 2px solid #eaeaea;
    @media screen and (max-width: 800px) {
      padding-top: 50px;
      padding-left: 0;
      border-top: 2px solid #eaeaea;
      border-left: none;
    }
  }
  .contain {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 0 !important;
    min-height: auto;
    @media screen and (max-width: 800px) {
      flex-direction: column;
    }
    & > div {
      width: 100%;
      @media screen and (max-width: 800px) {
        width: 100%;
      }
    }
    .inputs {
      @media screen and (max-width: 800px) {
        width: 100%;
        margin-top: 50px;
      }
      .input {
        // @media screen and (max-width: 800px){
        //   width: 100%;
        // }
      }
      .btns {
        display: flex;
        justify-content: flex-end;
        width: 100%;
        .loader {
          height: 50px;
          filter: brightness(0.96);
        }
        .success {
          font-size: 25px;
          color: #00bf6f;
          font-weight: bold;
          span {
            display: block;
            color: #132628;
            font-size: 16px;
            font-weight: 400;
            margin-top: 10px;
          }
        }
      }
    }
  }
}

.login-loader {
  height: 50px;
  display: block;
  width: auto !important;
}
</style>
